import {
	UseFetchServiceErrorItem,
	useDidMount,
	useShowHide,
} from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import React from 'react';
import { GLOBAL_LOADER } from './components/globalLoader';
import { getSessionStorage, saveSessionStorage } from './helpers/sessionHelper';
import { useHistory } from 'react-router-dom';

interface FetchResponse {
	data: {
		token: {
			accessToken: string;
			expiresIn: number;
			extendedExpiresIn: number;
			refreshToken: string;
		};
		applicationData: {
			applicationParameters: Record<string, Record<string, any>>;
		};
		externalInfo: Record<string, any>;
	};
	metadata: {
		success: boolean;
		errors: UseFetchServiceErrorItem[];
	};
}

export const FetchToken: React.FC = ({ children }) => {
	const ott = getSessionStorage('ott');
	const tokenOAuth = getSessionStorage('tokenOAuth');
	const [isInitializedApp, setIsInitializedApp] = React.useState(ott || tokenOAuth ? true : false);
	const { hide, show } = useShowHide(GLOBAL_LOADER);
	// use history instead of navigate = useNavigation, because redux isn't initialized
	const history = useHistory();

	useDidMount(() => {
		if (!isInitializedApp) {
			show();

			fetch('/token', {
				method: 'get',
				headers: {
					'content-type': 'application/json',
				},
				credentials: 'include',
			})
				.then((res) => res.json())
				.then((res: FetchResponse) => {
					if (res.metadata.success) {
						saveSessionStorage('tokenOAuth', res.data.token.accessToken);
						saveSessionStorage('state', decodeURIComponent(res.data.externalInfo.state));
						saveSessionStorage('plan', res.data.externalInfo.plan);
						saveSessionStorage('processId', res.data.externalInfo.pid);
					} else {
						history.push('serviceError');
					}
				})
				.catch((err) => {
					history.push('serviceError');
				})
				.finally(() => {
					hide();

					setIsInitializedApp(true);
				});
		}
	});

	return <>{isInitializedApp && children}</>;
};
